import React, { useEffect, useState } from 'react';
import './ConfermaBTN.scss'
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setSaldoGas } from '../../features/gasSlice';
import { useNavigate } from 'react-router';
import { CircularProgress, Dialog, DialogTitle, DialogActions } from '@mui/material';
import { setPath } from '../../features/settingSlice';
import { useLocation } from 'react-router-dom';
import { useFetchLogin } from '../../functions/login';



function ConfermaBTN(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const [open, setOpen] = useState(false)
    const [disable, setDisable] = useState(false)
    const saldo = useSelector((user) => user?.gas?.saldo)
    const section = useSelector((user) => user.settings.section)
    const [loader, setLoader] = useState(false)
    const {text, confermTxt, url, forward, disableAdd, type, handleSave, customFunc, sectionComponent} = props;
    const fetchLogin = useFetchLogin()

    useEffect(() => {
        dispatch(setPath(location.pathname))
    },[])

    const handleOpen = () => setOpen(!open)

    const editInfo = async () => {
        const { data } = await axios.get(url)
        if(data.success){
            customFunc()
            fetchLogin()
            navigate(forward)
        }
    }
    const doSomething = async () => {
        handleOpen()
        setLoader(true)
        setDisable(true)
        if(url !== 'none'){
            const { data } = await axios.get(url)
            if(data.success){
                section && dispatch(setSaldoGas(parseFloat(saldo) + parseFloat(props.amount)))
                if(customFunc){
                    customFunc()
                }
                setTimeout(() => {
                    navigate(forward)
                }, 0)
            } else {
                type === 'letture' ? alert(data.message) : navigate('/enrica/errore')
                setDisable(false)
                setLoader(false)
            }
        } else if(customFunc) {
            customFunc()
        } else {
            setTimeout(() => {
                navigate(forward)
            }, 0)
        }
    }
    
    return (
        <>
            <div className="confermaBtn">
                <button disabled={disableAdd || disable} onClick={() => handleOpen()}>{loader ? <CircularProgress/> : text}<ArrowForwardIos/></button>
            </div>
            <Dialog
                open={open}
                onClose={handleOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="dialog-popup"
            >
                <DialogTitle id="alert-dialog-title">
                    {confermTxt}
                </DialogTitle>
                <DialogActions>
                    <button onClick={handleOpen}>Annulla</button>
                    {location.pathname === '/enrica/piano-ricaricabile' ||
                    location.pathname === '/enrica/piano-relax' ||
                    location.pathname === '/enrica/piano-tradizionale' ? (
                        <button  autoFocus onClick={() => handleSave()}>
                            Conferma
                        </button>
                    ) : sectionComponent === 'editProfile' ? (
                        <button autoFocus onClick={() => editInfo()}>
                            Modifica Dati
                        </button>
                    ) : (
                        <button autoFocus onClick={() => doSomething()}>
                            Conferma
                        </button>
                    )}
                    
                </DialogActions>
            </Dialog>
        </>
  );
}

export default ConfermaBTN;
